<template>
  <div class="outcard culist-table">
    <h2>当前在线用户列表（{{ items.length }}）</h2>
    <div class="cardin">
      <tableAndPage :outerColumns="columns" :totalData="items"/>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: "Table_nowuserlist",
  data () {
    return {
      columns: [
        { title: "用户名", key: "nickname", },
        { title: "帐号", key: "account", },
        { title: "终端", key: "lgip", },
        { title: "浏览器", key: "lgbr", },
        // {
        //   title: "操作",
        //   key: "action",
        //   width: 160,
        //   align: "center",
        //   render: (h, params) => {
        //     return h("div",
        //     [
        //       h(
        //         "Button",
        //         {
        //           props: {
        //             size: "small"
        //           },
        //           style: {
        //             marginRight: "4px",
        //             padding:'1px 2px',
        //             background: '#28a745',
        //             border:'none'
        //           }
        //         },
        //         [
        //           h('img',{
        //             attrs:{
        //               src: require('../../assets/img/homenowuser/messagelineartable.png'),
        //             },
        //             style:{
        //               marginRight: '2px',
        //               transform: 'translateY(4px)'
        //             }
        //           }),
        //           h('span',{
        //             style:{
        //               display:'display:inline-block',
        //               transform:'translateY(1px)',
        //               fontSize:'12px',
        //               color: '#fff'
        //             }
        //           },"对话"),
        //         ]
        //       ),
        //       h(
        //         "Button",
        //         {
        //           props: {
        //             size: "small"
        //           },
        //           style: {
        //             right:"0",
        //             padding:'1px 2px',
        //             background: '#dc3545',
        //             border:'none'
        //           }
        //         },
        //         [
        //           h('img',{
        //             attrs:{
        //               src: require('../../assets/img/homenowuser/stoplinear.png'),
        //             },
        //             style:{
        //               marginRight: '2px',
        //               transform: 'translateY(3px)'
        //             }
        //           }),
        //           h('span',{
        //             style:{
        //               display:'inline-block',
        //               transform:'translateY(1px)',
        //               color: '#fff'
        //             }
        //           },"踢出"),

        //         ]
        //       )
        //     ]);
        //   }
        // }
      ],
      items: [],
    };
  },
  mounted () {
    this.getdata()
  },
  methods: {
    async getdata () {
      this.items = await this.$axios.cuonline()
    },
  }
};
</script>
<style lang="less">
.ivu-table-header thead th {
  background-color: #efefef;
  text-align: left;
  font-size: 12px;
  color: var(--main-black);
  font-weight: normal;
}
.ivu-table-body tbody tr td {
  color: var(--main-black);
  font-size: 12px;
}
</style>